/* eslint-disable import/no-anonymous-default-export */
import { useState } from "react";

export default () => {

    const [x, setX] = useState<number>();
    const [y, setY] = useState<number>();
    const [w, setW] = useState<number>();
    const [h, setH] = useState<number>();
    const [img, setImg] = useState<HTMLImageElement>();
    const [canvas, setCanvas] = useState<HTMLCanvasElement>();
    const [currentZoom, setCurrentZoom] = useState<number>(0);

    const crop = (x: number, y: number, w: number, h: number, img: HTMLImageElement, canvas: HTMLCanvasElement, zoom?: number) => {

        zoom = (zoom ?? currentZoom);

        const canvasContext = canvas.getContext('2d')!;
        const scale = Math.max(canvas.width / w, h / img.height) * (zoom + 1);


        canvasContext.drawImage(
            img,
            x - (w * (0.5 / (zoom + 1))),
            y - (h * (0.4 / (zoom + 1))),
            w,
            h,
            0,//(canvas.width - w) / 2,
            0,//(canvas.height - h) / 2,
            w * scale,
            h * scale);

        setX(x);
        setY(y);
        setW(w);
        setH(h);
        setImg(img);
        setCanvas(canvas);
        setCurrentZoom(zoom)

        return zoom;
    }

    const changeZoom = (zoom: number) => {
        if (!x || !y || !w || !h || !img || !canvas) {
            return;
        }

        if (zoom < 0) {
            zoom = 0;
        }

        return crop(x, y, w, h, img, canvas, zoom);
    }

    const incrementZoom = () => {
        return changeZoom((currentZoom) + 0.5);
    };

    const decrementZoom = () => {
        return changeZoom((currentZoom) - 0.5);
    };

    const generateFile  = () => {
        return new Promise<File | null>((resolve, reject) => {
            if(!canvas)
            {
                return resolve(null);
            }
            canvas?.toBlob((blob) => {
                if(!blob)
                {
                    return reject();
                }

                const file = new File([blob], "patente.png");
                resolve(file);
            });
        })
    };

    return { crop, changeZoom, incrementZoom, decrementZoom, generateFile };
};